export interface FooterConfig {
  callPortalUrl: string;
  linkedInUrl: string;
  instagramUrl: string;
  companyInfo: {
    cnpj: string;
    address: string;
    city: string;
    state: string;
    zipCode: string;
  };
}

export interface Configuration {
  id: string;
  name: string;
  value: string;
  description?: string;
}

const DEFAULT_FOOTER_CONFIG: FooterConfig = {
  callPortalUrl: 'https://chamados.ati.com.br',
  linkedInUrl: 'https://www.linkedin.com/company/ati-automacao-telecomunicacoes-e-informatica',
  instagramUrl: 'https://www.instagram.com/ati.com.br/',
  companyInfo: {
    cnpj: '22.311.228/0001-80',
    address: 'Rua Paulo Freire de Araújo, 280, Estoril',
    city: 'Belo Horizonte',
    state: 'MG',
    zipCode: '30494 280',
  },
};

export function formatCompanyInfo(
  info: FooterConfig['companyInfo']
): string {
  return `ATI CNPJ: ${info.cnpj} | ${info.address} | ${info.city} | ${info.state} | CEP: ${info.zipCode}`;
}

export default DEFAULT_FOOTER_CONFIG;
